export const NOTE_PRIORITIES = [
  { value: 'normal', label: 'Normal' },
  { value: 'important', label: 'Important' },
  { value: 'urgent', label: 'Urgent' },
];

const timestampValue = (value) => {
  if (typeof value === 'number') return value;
  const parsed = new Date(value || 0).getTime();
  return Number.isFinite(parsed) ? parsed : 0;
};

export const normalizeNotePriority = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  return NOTE_PRIORITIES.some((priority) => priority.value === normalized)
    ? normalized
    : 'normal';
};

export const normalizeNoteTags = (values, maximum = 6) => {
  const source = Array.isArray(values) ? values : [values];
  const seen = new Set();
  const tags = [];

  source.flatMap((value) => String(value || '').split(',')).forEach((value) => {
    const tag = value.trim().replace(/^#+/, '').replace(/\s+/g, ' ').slice(0, 30);
    const key = tag.toLocaleLowerCase();
    if (!tag || seen.has(key) || tags.length >= maximum) return;
    seen.add(key);
    tags.push(tag);
  });
  return tags;
};

/**
 * Convert the legacy flat notes collection into display threads. Old notes
 * have no parentId and remain roots; orphaned replies are surfaced as roots so
 * a deleted or malformed parent can never make a comment disappear.
 */
export const groupTeamNoteThreads = (notes) => {
  const normalized = (Array.isArray(notes) ? notes : [])
    .filter((note) => note && note.id)
    .map((note) => ({
      ...note,
      priority: normalizeNotePriority(note.priority),
      tags: normalizeNoteTags(note.tags || []),
    }));
  const byId = new Map(normalized.map((note) => [String(note.id), note]));
  const roots = normalized.filter((note) => !note.parentId || !byId.has(String(note.parentId)));
  const repliesByRoot = new Map();

  normalized.forEach((note) => {
    if (!note.parentId || !byId.has(String(note.parentId))) return;
    let rootId = String(note.parentId);
    const visited = new Set([String(note.id)]);
    while (byId.get(rootId)?.parentId && byId.has(String(byId.get(rootId).parentId)) && !visited.has(rootId)) {
      visited.add(rootId);
      rootId = String(byId.get(rootId).parentId);
    }
    if (!repliesByRoot.has(rootId)) repliesByRoot.set(rootId, []);
    repliesByRoot.get(rootId).push(note);
  });

  return roots
    .sort((left, right) => timestampValue(right.timestamp) - timestampValue(left.timestamp))
    .map((root) => ({
      root,
      replies: (repliesByRoot.get(String(root.id)) || [])
        .sort((left, right) => timestampValue(left.timestamp) - timestampValue(right.timestamp)),
    }));
};
